export default {
    "desayunos": [
        {
            "id": "1",
            "item": "Café americano",
            "price": "5.00",
            "quantity": "1"
        },
        {
            "id": "2",
            "item": "Café con leche",
            "price": "7.00",
            "quantity": "1"
        },
        {
            "id": "3",
            "item": "Sandwich de jamón y queso",
            "price": "10.00",
            "quantity": "1"
        },
        {
            "id": "4",
            "item": "Cocktail de frutas ",
            "price": "7.00",
            "quantity": "1"
        },
        {
            "id": "5",
            "item": "Jugo de naranja",
            "price": "7.00",
            "quantity": "1"
        }
    ],
    "comidas": [
        {
            "id": "6",
            "item": "Hamburguesa simple",
            "price": "10.00",
            "quantity": "1"
        },
        {
            "id": "7",
            "item": "Hamburguesa doble",
            "price": "15.00",
            "quantity": "1"
        },
        {
            "id": "8",
            "item": "Papas fritas",
            "price": "5.00",
            "quantity": "1"
        },
        {
            "id": "9",
            "item": "Aros de cebolla",
            "price": "5.00",
            "quantity": "1"
        },
        {
            "id": "10",
            "item": "Agua 500ml",
            "price": "5.00",
            "quantity": "1"
        },
        {
            "id": "11",
            "item": "Agua 750ml",
            "price": "7.00",
            "quantity": "1"
        },
        {
            "id": "12",
            "item": "Bebida/gaseosa 500ml",
            "price": "7.00",
            "quantity": "1"
        },
        {
            "id": "13",
            "item": "Bebida/gaseosa 750ml",
            "price": "10.00",
            "quantity": "1"
        }
    ]
}